import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icon } from "@azim-crm/icons";
import styles from "./Button.module.css";
const iconSize = { sm: 15, md: 16, lg: 18 };
/**
 * Botão do Azim CRM.
 * Variantes: primary, secondary, ghost, subtle, danger, inverse.
 * Tamanhos: sm, md, lg.
 * Suporta ícone à esquerda, direita ou ambos.
 * Aceita `ref` para controle de foco programático (forwardRef).
 */
export const Button = forwardRef(function Button({ variant = "secondary", size = "md", icon, iconRight, children, full = false, active = false, disabled = false, className, ...rest }, ref) {
    const cls = [
        styles.button,
        styles[size],
        styles[variant],
        full ? styles.full : "",
        active ? styles.active : "",
        disabled ? styles.disabled : "",
        className ?? "",
    ]
        .filter(Boolean)
        .join(" ");
    return (_jsxs("button", { ref: ref, type: "button", disabled: disabled, className: cls, ...rest, children: [icon && _jsx(Icon, { name: icon, size: iconSize[size] }), children && _jsx("span", { children: children }), iconRight && _jsx(Icon, { name: iconRight, size: iconSize[size] })] }));
});
//# sourceMappingURL=Button.js.map